import React from "react";

function CreatorsSection() {
  const creatorsData = [
    {
      image: "/assets/images/ProductionStudios.svg",
      title: "Production Studios",
      className: "title-production",
    },
    {
      image: "/assets/images/IndependentFilmmakers.svg",
      title: "Independent Filmmakers",
      className: "title-independent",
    },
    {
      image: "/assets/images/YouTubeCreators.svg",
      title: "YouTube Creators",
      className: "title-youtube",
    },
    {
      image: "/assets/images/ShortFilmCreators.svg",
      title: "Short Film Creators",
      className: "title-shortfilm",
    },
    {
      image: "/assets/images/DocumentaryProducers.svg",
      title: "Documentary Producers",
      className: "title-documentary",
    },
    {
      image: "/assets/images/AnimationWebSeriescreators.svg",
      title: "Animation & Web Series creators",
      className: "title-animation",
    },
  ];

  return (
    <section className="partnership-section creators-section">
      <div className="container creators-container">
        <div className="text-center mb-5">
          <h2 className="partnership-title">Content Creators We Support</h2>
          <p className="partnership-desc">
            If you create professional, legally-owned video content — you can{" "}
            <br />
            distribute on Fawesome.
          </p>
        </div>

        <div className="row gx-5 gy-4">
          {creatorsData.map((creator, index) => (
            <div className="col-lg-6 col-md-6" key={index}>
              <div className="creator-card creator-card-container">
                <img
                  src={creator.image}
                  alt={creator.title}
                  className="creator-card-img"
                />
                <div className="creator-card-overlay d-none">
                  <div className="creator-text-wrapper">
                    <div className="creator-accent-bar"></div>
                    <h3
                      className={`creator-card-title ${creator.className || ""}`}
                    >
                      {creator.title}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* DIVFOOTER 3 - Bottom transition divider */}
      <div className="partnership-footer-divider">
        <img src="/assets/images/devfooter3.svg" alt="" className="img-fluid" />
      </div>
    </section>
  );
}

export default CreatorsSection;
